// extracted by mini-css-extract-plugin
export default {"Modal":"CreateFolderModal_Modal__z9Q3e"};